module.exports = __webpack_public_path__ + "static/media/messenger.4758ff14.svg";